(function(){
  // Bail early if config is missing
  if (
    !window.freeGiftConfig ||
    !Array.isArray(window.freeGiftConfig.tiers) ||
    window.freeGiftConfig.tiers.length < 1
  ) {
    console.warn("freeGiftConfig.tiers missing or invalid → skipping free-gift logic");
    return;
  }

  // Cache DOM nodes
  var overlay             = document.getElementById("free-gift-overlay"),
      swatchContainer     = document.getElementById("free-gift-swatches"),
      previewImage        = document.getElementById("free-gift-preview"),
      hiddenInput         = document.getElementById("free-gift-selected-variant"),
      confirmBtn          = document.getElementById("free-gift-confirm"),
      closeBtn            = document.getElementById("free-gift-close"),
      CART_CHECK_INTERVAL = 1500;

  function fetchCart() {
    return fetch("/cart.js")
      .then(res => res.json())
      .catch(err => {
        console.error("Error fetching cart.js:", err);
        return null;
      });
  }

  function getActiveTier(total) {
    var idx = -1;
    window.freeGiftConfig.tiers.forEach(function(t,i){
      if (total >= t.threshold) idx = i;
    });
    return idx;
  }

  function findAnyGiftLineIndex(cart) {
    if (!cart || !cart.items) return null;
    for (var i=0; i<cart.items.length; i++) {
      if (window.freeGiftConfig.tiers.some(t => t.productId === cart.items[i].product_id)) {
        return i + 1;
      }
    }
    return null;
  }

  function isGiftTierInCart(cart, tierIndex) {
    if (!cart || !cart.items) return false;
    var pid = window.freeGiftConfig.tiers[tierIndex].productId;
    return cart.items.some(item => item.product_id === pid);
  }

  function showModal(){
    overlay && (overlay.style.display = "flex");
  }
  function hideModal(){
    overlay && (overlay.style.display = "none");
  }

  function addGiftToCart(vid) {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: {"Content-Type":"application/json"},
      body: JSON.stringify({ id: vid, quantity: 1 })
    })
    .then(res => res.json())
    .catch(err => console.error("Error adding gift:", err));
  }

  function removeAnyGiftFromCart(line) {
    if (!line) return Promise.resolve();
    return fetch("/cart/change.js", {
      method: "POST",
      headers: {"Content-Type":"application/json"},
      body: JSON.stringify({ line: line, quantity: 0 })
    })
    .then(res => res.json())
    .catch(err => console.error("Error removing gift:", err));
  }

  // ─── NEW: works with input[name="updates[]"] + +/- siblings ───
  function freezeGiftQtyInputs(lineIndex) {
    // grab all of theme's qty inputs (they're all named "updates[]")
    var inputs = document.querySelectorAll('input[name="updates[]"]');
    var input  = inputs[lineIndex - 1];
    if (!input) return;

    // make the number field readonly & faded
    input.value = 1;
    input.setAttribute("readonly", true);
    input.style.opacity = "0.6";

    // disable its plus/minus siblings
    [input.previousElementSibling, input.nextElementSibling].forEach(el => {
      if (!el) return;
      // common tag for +/- is BUTTON, but could be <a> or div[role=button]
      if (el.tagName === "BUTTON" || el.getAttribute("role") === "button" || el.tagName === "A") {
        el.setAttribute("disabled", true);
        el.style.pointerEvents = "none";
        el.style.opacity = "0.4";
      }
    });
  }

  function enforceGiftQuantity(cart) {
    if (!cart || !cart.items) return;
    var line = findAnyGiftLineIndex(cart);
    if (!line) return;

    var item = cart.items[line - 1];
    if (item.quantity !== 1) {
      fetch("/cart/change.js", {
        method: "POST",
        headers: {"Content-Type":"application/json"},
        body: JSON.stringify({ line: line, quantity: 1 })
      })
      .then(() => document.body.dispatchEvent(new Event("cart:updated")))
      .catch(err => console.error("Error enforcing qty:", err));
    }

    freezeGiftQtyInputs(line);
  }

  function initSwatchClicks(){
    if (!swatchContainer || !previewImage || !hiddenInput) return;
    swatchContainer.querySelectorAll(".free-gift-swatch").forEach(label => {
      label.addEventListener("click", evt => {
        evt.preventDefault();
        // clear old
        swatchContainer.querySelectorAll(".free-gift-swatch:not(.hidden)").forEach(el => {
          var box = el.querySelector("div");
          box && (box.style.borderColor = "#ddd");
          el.classList.remove("swatch--selected");
        });
        // select this
        label.classList.add("swatch--selected");
        var box = label.querySelector("div");
        box && (box.style.borderColor = "#000");

        // update hidden + preview
        var vid = parseInt(label.getAttribute("data-variant-id"),10);
        hiddenInput.value = vid;
        var vobj = null;
        window.freeGiftConfig.tiers.forEach(t => {
          t.variants.forEach(v => { if (v.id === vid) vobj = v; });
        });
        if (vobj) {
          previewImage.src = vobj.imageUrl;
          previewImage.alt = vobj.imageAlt;
        }
      });
    });
  }

  function showSwatchesForTier(tier) {
    swatchContainer.querySelectorAll(".free-gift-swatch").forEach(label => {
      var t = parseInt(label.getAttribute("data-tier"),10);
      label.classList[t === tier ? "remove" : "add"]("hidden");
      var box = label.querySelector("div");
      box && (box.style.borderColor = "#ddd");
      label.classList.remove("swatch--selected");
    });
    var first = swatchContainer.querySelector('.free-gift-swatch[data-tier="'+tier+'"]:not(.hidden)');
    if (first) first.click();
    else {
      hiddenInput.value = "";
      previewImage.src = "";
      previewImage.alt = "";
      hideModal();
    }
  }

  function checkCartAndMaybeShow(){
    if (overlay && overlay.style.display === "flex") return;
    fetchCart().then(cart => {
      if (!cart) return;

      // purge if empty, discount, or combo
      if (cart.item_count === 0 ||
          (cart.discount_codes||[]).length > 0 ||
          cart.items.some(i => (i.discount_allocations||[]).length > 0 || (i.properties||{}).combo)
      ) {
        hideModal();
        var idx = findAnyGiftLineIndex(cart);
        idx && removeAnyGiftFromCart(idx);
        return;
      }

      // enforce qty & freeze controls
      enforceGiftQuantity(cart);

      var tier = getActiveTier(cart.total_price),
          existing = findAnyGiftLineIndex(cart);

      if (tier < 0) {
        existing && removeAnyGiftFromCart(existing);
        hideModal();
        return;
      }

      // if current gift is wrong tier, swap it
      if (existing) {
        var currTier = window.freeGiftConfig.tiers.findIndex(t => t.productId === cart.items[existing - 1].product_id);
        if (currTier !== tier) {
          removeAnyGiftFromCart(existing).then(()=>{
            showSwatchesForTier(tier);
            showModal();
          });
          return;
        }
      }

      // if correct gift present, done
      if (isGiftTierInCart(cart,tier)) {
        hideModal();
      } else {
        showSwatchesForTier(tier);
        showModal();
      }
    });
  }

  // DOM ready
  document.addEventListener("DOMContentLoaded", function(){
    initSwatchClicks();
    checkCartAndMaybeShow();
    document.body.addEventListener("cart:updated", ()=>{
      checkCartAndMaybeShow();
      setTimeout(checkCartAndMaybeShow, CART_CHECK_INTERVAL);
    });
    setInterval(checkCartAndMaybeShow, CART_CHECK_INTERVAL);

    closeBtn && closeBtn.addEventListener("click", e=>{
      e.preventDefault();
      hideModal();
    });
    confirmBtn && confirmBtn.addEventListener("click", e=>{
      e.preventDefault();
      var vid = parseInt(hiddenInput.value,10);
      if (vid) {
        addGiftToCart(vid).then(()=>{
          hideModal();
          window.location.reload();
          window.location.href = "/cart";
        });
      }
    });
  });
})();
